export default "__VITE_ASSET__BZiDuCBy__"